// TODO: create new theme variables
export const SHADOW_COLORS = ['level_2', 'level_3', 'level_0'] as const;
